import { Component, ElementRef, OnInit, Input, ViewChild, Self, Optional, HostBinding } from '@angular/core';
import { AbstractControl, Validators, NgControl, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-required-text',
  templateUrl: './required-text.component.html',
  styleUrls: ['./required-text.component.scss'],
  providers: [],
})
export class RequiredTextComponent implements ControlValueAccessor, OnInit {
  @ViewChild('input') input: ElementRef;
  @HostBinding('attr.id') id = '';
  @Input() placeHolder: string;

  disabled: boolean;
  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(
    @Optional()
    @Self()
    public controlDir: NgControl) {
    controlDir.valueAccessor = this;
  }

  ngOnInit() {
    const control = this.controlDir.control;
    const validators = control.validator
      ? [control.validator, Validators.required]
      : Validators.required;
    control.setValidators(validators);
    control.updateValueAndValidity();
  }

  writeValue(value: any) {
    // write value to view
    if (value) {
      this.input.nativeElement.value = value;
    }
  }

  registerOnChange(fn: (value: any) => void) {
    // save callback to call on change
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: any) => void) {
    // save callback to call when touched
    this.onTouched = fn;
  }

  setDisableState(disabled: boolean): void {
    // disable or enable the field
    this.disabled = disabled;
  }

  validate(ctrl: AbstractControl) {
    return Validators.required(ctrl);
  }
}
